// Shared by sub_nav_scroll_controller and custom_select_controller: both render a Bootstrap
// .dropdown-menu inside an ancestor that clips overflow (the scrollable sub-nav; a filter bar
// that can itself scroll under a sticky page header), which needs the same escape hatch. See
// sub_nav_scroll_controller's own comment for the two dead ends that don't work: a plain CSS
// overflow: visible override (overflow-x and overflow-y are linked by spec, so making one auto
// makes both auto even if the other is explicitly set to visible), and popperConfig's own
// strategy: "fixed" (Bootstrap's dropdown.js disables Popper's applyStyles modifier entirely for
// any toggle inside a real .navbar, so Popper computes a position but never writes it to the DOM).
//
// position: fixed (not absolute, which Bootstrap's own .dropdown-menu default already is, and
// exactly what gets clipped) is what actually escapes the clipping ancestor: a fixed element
// positions relative to the viewport itself, outside any ancestor's own clipping box. Coordinates
// come straight from the toggle's own real on-screen position (getBoundingClientRect already
// accounts for the page's current scroll offset), computed fresh on every open rather than once,
// so this stays correct after scrolling.
export function positionDropdownMenu(toggle, menu) {
  const rect = toggle.getBoundingClientRect()

  menu.style.position = "fixed"
  menu.style.top = `${rect.bottom}px`
  menu.style.left = `${rect.left}px`
  menu.style.right = "auto"
  menu.style.margin = "0"
}
